import React from 'react';
import { BulkOperationItem } from '../BulkOperationQueue.interface';
import { AiScore } from './AiScore';
import { ImportCsv } from './ImportCsv';
import { ExportCsv } from './ExportCsv';
import { RejectCandidates } from './RejectCandidates';
import { MoveToStage } from './MoveToStage';
import { SendEmail } from './SendEmail';
import { DefaultItem } from './DefaultItem';

// Supported action types
export type ActionType =
  | 'ai_score'
  | 'export_csv'
  | 'csv_import'
  | 'reject'
  | 'move_stage'
  | 'merge'
  | 'delete'
  | 'send_email';

// Props that all action item components receive
export interface ActionItemProps {
  item: BulkOperationItem;
  activityType: string;
}

// Registry mapping action types to their components
const actionComponentRegistry: Record<
  string,
  React.ComponentType<ActionItemProps>
> = {
  // AI scoring
  ai_score: AiScore,
  ai_scoring: AiScore,
  // CSV
  csv_import: ImportCsv,
  import_csv: ImportCsv,
  export_csv: ExportCsv,
  bulk_export: ExportCsv,
  // Reject
  reject: RejectCandidates,
  reject_candidate: RejectCandidates,
  reject_candidates: RejectCandidates,
  // Move to stage
  move_stage: MoveToStage,
  move_to_stage: MoveToStage,
  // Email
  send_email: SendEmail,
  bulk_email: SendEmail,
  // Add to project/job/flow - use DefaultItem
  add_to_project: DefaultItem,
  add_project: DefaultItem,
  add_to_job: DefaultItem,
  add_job: DefaultItem,
  add_to_flow: DefaultItem,
  add_flow: DefaultItem,
  // Tags
  add_tag: DefaultItem,
  add_tags: DefaultItem,
  // Self-schedule and Hireflix
  self_schedule: DefaultItem,
  send_self_schedule: DefaultItem,
  hireflix: DefaultItem,
  send_hireflix: DefaultItem,
  // Other actions
  merge: DefaultItem,
  delete: DefaultItem,
  user_import: ImportCsv,
  create_contact: DefaultItem,
  // Reactivate
  reactivate: DefaultItem,
  unreject: DefaultItem,
  reactivate_application: DefaultItem,
  // Kombo document upload
  kombo_document_upload: DefaultItem,
};

/**
 * Get the component for a specific action type
 * Falls back to DefaultItem if no specific component is registered
 */
export const getActionComponent = (
  actionType: string
): React.ComponentType<ActionItemProps> => {
  return actionComponentRegistry[actionType] || DefaultItem;
};

/**
 * Register a custom action component
 * Useful for extending with new action types
 */
export const registerActionComponent = (
  actionType: string,
  component: React.ComponentType<ActionItemProps>
) => {
  actionComponentRegistry[actionType] = component;
};
